import { type ActionReducerMap } from '@ngrx/store';

import { filesReducer } from './files/files.reducer';
import { navigationReducer } from './navigation/navigation.reducer';
import { settingsReducer } from './settings/settings.reducer';
import { type UploaderState } from './uploader/uploader.state';

export const reducers: ActionReducerMap<UploaderState> = {
  files: filesReducer,
  navigation: navigationReducer,
  settings: settingsReducer,
};
